<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2.5" y="2.5" width="6.66667" height="15" rx="2" fill="#0012FA" />
    <rect x="2.5" y="2.5" width="15" height="15" rx="3" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round"
      stroke-linejoin="round" />
    <path d="M8.74992 2.5V17.5" stroke="#0012FA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.83325 12.9167V7.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
<script setup lang="ts"></script>